<template>
  <div style="height: 100%;">
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>道闸设备</span>
    </div>
    <div style="overflow-y: auto; height: 84%;margin-top: 4%">
      <div v-if="videoList.length>0">
        <div v-for="item in videoList" :key="item.id">
          <el-row class="recordInfo">
            <div>
              <div style="margin-bottom: 5px;">
              <span class="recordTitle">{{ item.cnName }}
              </span>
                <span style="width: 50px;display: inline-block"  :style="{color: item.status === '在线' ? '#00D488' : item.status === '离线' ?  '#F95453' : '#9A9FA4'}">
                ●&nbsp;{{
                    item.status }}</span>
              </div>
              <span>
               <img class="recordImg" v-if="item.carPic === null || item.carPic === '' " src="../../../assets/images/noteCat.png"/>
               <img class="recordImg" v-if="item.carPic" :src="item.carPic"/>
          </span>
              <ul
                style="display: flex;flex-direction: row;justify-content:flex-start;margin: 0;padding: 0;padding-top: 15px;">
                <li>今日进场车辆：<span style="color: #299BFF;">{{ item.enterCount }}</span></li>
                <li style="padding-left: 80px">今日出场车辆：<span style="color: #ECBB18;padding-top: 3px;">{{ item.leaveCount }}</span></li>
              </ul>
            </div>
          </el-row>
        </div>
      </div>
      <div v-else style="height: 100%;padding-top: 20%">
        <no-data></no-data>
      </div>
    </div>

  </div>
</template>

<script>
import {getParkingDetailsParentAccess} from "@/network/car-access";
import NoData from "@/components/NoData";

export default {
  name: "CarAccessMonitoring",
  mounted() {
    this.getLinkage();
    setInterval(() => {
      this.getLinkage();
    }, 5000);

  },
  components:{
    NoData
  },
  created() {
    clearInterval(this.getLinkage)
  },
  data() {
    return {
      videoList: {}
    }
  },
  methods: {
    getLinkage() {
      getParkingDetailsParentAccess().then(res => {
        if (res.data != null) {
          if (res.data == this.videoList) {
            return;
          } else {
            this.videoList = res.data;
          }
        }
      })
    }
  }
}

</script>

<style scoped>
.recordInfo {
  width: 310px;
  height: 260px;
  padding-top: 21px;
  border: 1px solid rgb(17, 68, 111);
  border-radius: 2px;
  padding-left: 18px;
  margin-left: 10%;
  font-size: 12px;
  margin-bottom: 10px;
}

.recordTitle {
  width: 104px;
  height: 16px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #FFFFFF;
  opacity: 1;
  padding-right: 135px;
}

ul li {
  list-style: none;
  color: #9A9FA4;
}

.openBtn {
  margin: 0;
  padding: 0;
  width: 20px;
  height: 18px;
  background: rgba(18, 72, 118);
  border-color: rgba(18, 72, 118);
  opacity: 1;
  border-radius: 2px;
  font-size: 12px;
  font-weight: normal;
  color: #FFFFFF;
}

.closeBtn {
  margin: 0;
  padding: 0;
  width: 20px;
  height: 18px;
  background: rgba(102, 43, 49);
  border-color: rgba(102, 43, 49);
  opacity: 1;
  border-radius: 2px;
  font-size: 12px;
  font-weight: normal;
  color: #FFFFFF;
}

.recordImg {
  width: 275px;
  height: 162px;
  background: rgba(0, 0, 0, 0);
  opacity: 1;
}

.openBtn {
  width: 20px;
  height: 18px;
  background: rgba(18, 72, 118);
  opacity: 1;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
  margin-right: 4px;
}

.btnFont {
  width: 4px;
  height: 4px;
  opacity: 1;
  border-radius: 2px;
}

.closeBtn {
  width: 20px;
  height: 18px;
  background: rgba(102, 43, 49);
  opacity: 1;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
}
</style>
